var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResidentes = function SvgResidentes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 56,
    fill: "none",
    viewBox: "0 0 44 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#residentes_svg__clip0_465_248)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#19D3C5",
    d: "M21.996 55.51c12.148 0 21.996-9.972 21.996-22.273s-9.848-22.273-21.996-22.273S0 20.936 0 33.237 9.848 55.51 21.996 55.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M21.362 25.628c5.8 0 10.502-4.762 10.502-10.635S27.162 4.358 21.361 4.358c-5.8 0-10.502 4.761-10.502 10.635s4.702 10.635 10.503 10.635"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "M16.447 26.928h10.368c5.136 0 9.314 4.222 9.314 9.431v14.977c0 2.577-2.061 4.664-4.605 4.664H11.746c-2.545 0-4.605-2.087-4.605-4.664V36.36c0-5.2 4.169-9.43 9.313-9.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M26.926 26.928c0 2.962-2.37 5.362-5.295 5.362s-5.295-2.4-5.295-5.362z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "M11.018 13.171s3.971.931 8.957-.746c0 0 .673.93 2.83.497s3.384-2.303 3.384-2.303 1.165 2.552 5.596 3.178c0 0 .246 1.678-.245 3.74 0 0 2.41-2.937 1.957-7.576-.42-4.343-3.487-6.799-6.143-6.373 0 0-4.819-5.627-12.516-2.786C5.28 4.334 7.99 15.42 11.002 16.782c0 0-.206-1.677.016-3.61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "residentes_svg__clip0_465_248"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h44v56H0z"
  })))));
};
export default SvgResidentes;